import { render, staticRenderFns } from "./customerBillDetails.vue?vue&type=template&id=41470467&scoped=true"
import script from "./customerBillDetails.vue?vue&type=script&lang=js"
export * from "./customerBillDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41470467",
  null
  
)

export default component.exports